"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiPopover = require("@tencent/spaui-popover");

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ItemComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ItemComponent, _React$PureComponent);

  function ItemComponent(props) {
    var _this;

    _classCallCheck(this, ItemComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ItemComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleShow", function (event, show) {
      _this.setState({
        show: show
      });
    });

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(ItemComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props = this.props,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? {} : _this$props$data,
          itemClassName = _this$props.itemClassName,
          itemActions = _this$props.itemActions,
          itemActionsClassName = _this$props.itemActionsClassName,
          onItemClick = _this$props.onItemClick,
          baseClass = _this$props.baseClass,
          _this$props$showHelpO = _this$props.showHelpOnHover,
          showHelpOnHover = _this$props$showHelpO === void 0 ? true : _this$props$showHelpO,
          OverlayTriggerProps = _this$props.OverlayTriggerProps,
          PopOverProps = _this$props.PopOverProps,
          checkable = _this$props.checkable,
          ItemActionsComponent = _this$props.ItemActionsComponent,
          _this$props$ItemCheck = _this$props.ItemCheckComponent,
          ItemCheckComponent = _this$props$ItemCheck === void 0 ? null : _this$props$ItemCheck,
          itemWidth = _this$props.itemWidth,
          itemHeight = _this$props.itemHeight,
          itemStyle = _this$props.itemStyle,
          ItemDataComponent = _this$props.ItemDataComponent,
          itemIndex = _this$props.itemIndex;
      var _data$label = data.label,
          label = _data$label === void 0 ? '' : _data$label,
          _data$desc = data.desc,
          desc = _data$desc === void 0 ? '' : _data$desc,
          _data$icon = data.icon,
          icon = _data$icon === void 0 ? '' : _data$icon,
          prefix = data.prefix,
          suffix = data.suffix,
          extra = data.extra,
          className = data.className,
          checked = data.checked,
          tips = data.tips,
          status = data.status;
      var show = this.state.show;

      var actions = itemActions && itemActions.length > 0 && _react["default"].createElement("ul", {
        className: itemActionsClassName,
        key: "actions"
      }, itemActions.map(function (Action, i) {
        var actionComponent = null;

        if ((0, _spauiUtils.isReactNode)(Action)) {
          actionComponent = Action;
        } else {
          actionComponent = _react["default"].createElement(Action, _extends({
            data: data
          }, _this2.props));
        }

        return [_react["default"].createElement("li", {
          key: "".concat(baseClass, "-item-action-").concat(i)
        }, actionComponent), i !== itemActions.length - 1 && _react["default"].createElement("li", {
          className: "".concat(baseClass, "-item-action-split"),
          key: "".concat(baseClass, "-item-action-split-").concat(i)
        })];
      }));

      var overlayProps = _objectSpread({
        overlay: _react["default"].createElement(_spauiPopover.PopOver, PopOverProps, tips),
        placement: 'right',
        onShow: this.handleShow
      }, OverlayTriggerProps);

      var checkmark = null;

      if (checkable) {
        checkmark = (0, _spauiUtils.isReactNode)(ItemCheckComponent) ? _react["default"].createElement("i", {
          className: "spaui-list-item-check"
        }, ItemCheckComponent) : _react["default"].createElement(ItemCheckComponent, {
          checked: checked
        });
      }

      var itemProps = {
        className: (0, _classnames["default"])(itemClassName, className, (_classNames = {}, _defineProperty(_classNames, "has-".concat(status), status), _defineProperty(_classNames, 'spaui-state-hover', show), _defineProperty(_classNames, "checked", checked), _classNames)),
        onClick: function onClick(event) {
          if ((0, _spauiUtils.isFunction)(onItemClick)) {
            onItemClick(event, data, _this2.props);
          }
        },
        style: _objectSpread({
          width: itemWidth,
          height: itemHeight
        }, itemStyle),
        role: 'listitem'
      };
      var content = !ItemDataComponent ? _react["default"].createElement("div", itemProps, prefix, checkmark, icon ? _react["default"].createElement("div", {
        className: "".concat(baseClass, "-item-icon")
      }, _react["default"].createElement("img", {
        src: icon,
        alt: ""
      })) : null, _react["default"].createElement("div", {
        className: "".concat(baseClass, "-item-content")
      }, label ? _react["default"].createElement("div", {
        className: "".concat(baseClass, "-item-title")
      }, label) : null, desc ? _react["default"].createElement("div", {
        className: "".concat(baseClass, "-item-desc")
      }, desc) : null), extra ? _react["default"].createElement("div", {
        className: "".concat(baseClass, "-item-extra")
      }, extra) : null, actions, ItemActionsComponent && _react["default"].createElement(ItemActionsComponent, _extends({
        data: data
      }, this.props)), tips && showHelpOnHover === true ? _react["default"].createElement(_spauiPopover.OverlayTrigger, overlayProps, _react["default"].createElement("i", {
        className: "spaui-icon-tips spaui-hover-visible"
      }, _react["default"].createElement(_spauiIcon["default"], {
        className: "spaui-svg-icon-tip",
        name: "question-filled"
      }))) : null, suffix) : _react["default"].createElement(ItemDataComponent, _extends({
        data: data,
        checkmark: checkmark,
        actions: actions,
        itemIndex: itemIndex
      }, itemProps));
      return showHelpOnHover === true || !tips ? content : _react["default"].createElement(_spauiPopover.OverlayTrigger, overlayProps, content);
    }
  }]);

  return ItemComponent;
}(_react["default"].PureComponent);

var _default = ItemComponent;
exports["default"] = _default;